import { Form as AntForm } from 'antd';
import styled from 'styled-components';

function getGridColumns(value) {
  if (!value) return value;
  return `grid-template-columns: repeat(${value}, 1fr)`;
}

const Form = styled(AntForm)``;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Grid = styled.div`
  display: grid;
  column-gap: 1rem;
  ${({ columns }) => getGridColumns(columns)};
`;

Form.Footer = Footer;
Form.Grid = Grid;

export default Form;
